import { render } from "./WordTraining.vue?vue&type=template&id=6287645a&scoped=true&ts=true"
import script from "./WordTraining.vue?vue&type=script&lang=ts"
export * from "./WordTraining.vue?vue&type=script&lang=ts"

import "./WordTraining.vue?vue&type=style&index=0&id=6287645a&scoped=true&lang=css"

import exportComponent from "/Users/eugene/My/Projects/ek22f/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6287645a"]])

export default __exports__